/// <reference path="../../../components/controls/presets/presets-list.ts" />

module Meevo.Plugins.ReportScheduler {
    "use strict";
    import IReportGeneralInfo = Meevo.Model.IReportGeneral;
    import PresetStatus = Meevo.Components.Controls.PresetStatus;
    /**
    * Main Section
    */
    interface StandingFrequency {
        id: Meevo.Model.DateTimeUnitsEnum;
        displayName: string;
    }

    enum TimeRangeEnum {
        Midnight,
        OneAm,
        TwoAm,
        ThreeAm,
        FourAm,
        FiveAm,
        SixAm,
        SevenAm,
        EightAm,
        NineAm,
        TenAm,
        ElevenAm,
        Noon,
        OnePm,
        TwoPm,
        ThreePm,
        FourPm,
        FivePm,
        SixPm,
        SevenPm,
        EightPm,
        NinePm,
        TenPm,
        ElvenPm
    }

    export class MainSection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<Model.ReportScheduler> {
        public readonly DAY_OF_WEEK_CHOICE: string = "1";
        public readonly DAY_OF_MONTH_CHOICE: string = "2";

        selectedReport: IReportGeneralInfo;
        numberOfOccurrencesChoice = "1";
        endByChoice = "2";
        isPerpetualChoice = "3";
        endingChoice = this.isPerpetualChoice;
        monthlyChoice = this.DAY_OF_WEEK_CHOICE;
        defaultEndDate: any = moment().startOf("day").toDate();
        defaultTotalOccurrences = 1;
        defaultOccurrenceInterval = 14;
        defaultDayOfMonth = 1;
        startTimeTemp: any;
        serviceCriteria: any;
        serviceAddOnPermission: boolean = false;
        daysRef: any;
        frequencyUnitReferenceData: any;
        days: any;
        selectedDaysList: any;
        selectedWeekOccurrence: any;
        customAddressName: string;
        customAddressEmail: string;
        customAddressSMS: string;
        customAddressSMSCountryCode: string;
        customAddressSMSIgnoreValidation: boolean;
        selectedFrequency: StandingFrequency;
        smartMoveProperties: string[];
        userSmartMoveProperties: string[];
        timeRangeValues: any;
        startTimeRangeValue: number;
        isLoading: boolean;
        reportFormatList: any;
        reportFormat: any;

        constructor(sectionId: number,
            displayNameContentKey: string,
            template: string,
            isPrimarySection: boolean,
            handlesOwnCrud: boolean,
            baseEndpoint: string,
            sectionEndpoint: string,
            loggingService: Meevo.Components.Logging.ILoggingService,
            dataService: Meevo.Components.BaseClasses.IDataService,
            identityService: Meevo.Components.Common.IIdentityService,
            noun: Meevo.Model.NounEnum,
            appSettings: Meevo.Components.Common.IAppSettings,
            sectionSecurityKey: string,
            public $translate: angular.translate.ITranslateService,
            public modalService: Meevo.Components.Modal.IModalService,
            public $scope: ng.IScope,
            public context: ReportSchedulerContext
        ) {

            super(
                sectionId,
                displayNameContentKey,
                template,
                isPrimarySection,
                handlesOwnCrud,
                baseEndpoint,
                sectionEndpoint,
                loggingService,
                dataService,
                identityService,
                noun,
                appSettings,
                sectionSecurityKey);

            this.isLoading = true;
            this.customAddressName = '';
            this.customAddressEmail = '';
            this.customAddressSMS = '';
            this.customAddressSMSIgnoreValidation = false;

            this.startTimeTemp = {
                value: moment("09:00", "HH:mm").toDate()
            };

            this.daysRef = {
                0: $translate.instant("LABEL_SUNDAY"),
                1: $translate.instant("LABEL_MONDAY"),
                2: $translate.instant("LABEL_TUESDAY"),
                3: $translate.instant("LABEL_WEDNESDAY"),
                4: $translate.instant("LABEL_THURSDAY"),
                5: $translate.instant("LABEL_FRIDAY"),
                6: $translate.instant("LABEL_SATURDAY")
            }

            this.smartMoveProperties = ["employeeCategoryList", "employeeRecipientList"];
            this.userSmartMoveProperties = ["userRecipientList"];

            let days = [];
            for (var i = 1; i <= 31; i++) {
                days.push(i);
            }
            this.days = days;
            this.days.push(-1); // last day

            this.frequencyUnitReferenceData = [
                { id: Meevo.Model.DateTimeUnitsEnum.Daily, displayName: this.$translate.instant("LABEL_DAILY"), counterName: this.$translate.instant("LABEL_DAYS") + " ", isVisible: true },
                { id: Meevo.Model.DateTimeUnitsEnum.Weekly, displayName: this.$translate.instant("LABEL_WEEKLY"), counterName: this.$translate.instant("LABEL_WEEKS") + " ", isVisible: true },
                { id: Meevo.Model.DateTimeUnitsEnum.Monthly, displayName: this.$translate.instant("LABEL_MONTHLY"), counterName: this.$translate.instant("LABEL_MONTHS") + " ", isVisible: true }
            ];

            this.timeRangeValues = [
                //{ enumValue: TimeRangeEnum.Midnight, labelValue12: "LABEL_MIDNIGHT_RANGE", labelValue24: "LABEL_MIDNIGHT_RANGE"  },
                //{ enumValue: TimeRangeEnum.OneAm, labelValue12: "LABEL_ONEAM_RANGE", labelValue24: "LABEL_ONEAM24_RANGE"  },
                //{ enumValue: TimeRangeEnum.TwoAm, labelValue12: "LABEL_TWOAM_RANGE", labelValue24: "LABEL_TWOAM24_RANGE"  },
                //{ enumValue: TimeRangeEnum.ThreeAm, labelValue12: "LABEL_THREEAM_RANGE", labelValue24: "LABEL_THREEAM24_RANGE"  },
                //{ enumValue: TimeRangeEnum.FourAm, labelValue12: "LABEL_FOURAM_RANGE", labelValue24: "LABEL_FOURAM24_RANGE"  },
                //{ enumValue: TimeRangeEnum.FiveAm, labelValue12: "LABEL_FIVEAM_RANGE", labelValue24: "LABEL_FIVEAM24_RANGE"  },
                { enumValue: TimeRangeEnum.SixAm, labelValue12: "LABEL_SIXAM_RANGE", labelValue24: "LABEL_SIXAM24_RANGE" },
                { enumValue: TimeRangeEnum.SevenAm, labelValue12: "LABEL_SEVENAM_RANGE", labelValue24: "LABEL_SEVENAM24_RANGE" },
                { enumValue: TimeRangeEnum.EightAm, labelValue12: "LABEL_EIGHTAM_RANGE", labelValue24: "LABEL_EIGHTAM24_RANGE"  },
                { enumValue: TimeRangeEnum.NineAm, labelValue12: "LABEL_NINEAM_RANGE", labelValue24: "LABEL_NINEAM24_RANGE"  },
                { enumValue: TimeRangeEnum.TenAm, labelValue12: "LABEL_TENAM_RANGE", labelValue24: "LABEL_TENAM24_RANGE"  },
                //{ enumValue: TimeRangeEnum.ElevenAm, labelValue12: "LABEL_ELEVENAM_RANGE", labelValue24: "LABEL_ELEVENAM24_RANGE"  },
                //{ enumValue: TimeRangeEnum.Noon, labelValue12: "LABEL_NOON_RANGE", labelValue24: "LABEL_NOON24_RANGE"  },
                //{ enumValue: TimeRangeEnum.OnePm, labelValue12: "LABEL_ONEPM_RANGE", labelValue24: "LABEL_ONEPM24_RANGE"  },
                //{ enumValue: TimeRangeEnum.TwoPm, labelValue12: "LABEL_TWOPM_RANGE", labelValue24: "LABEL_TWOPM24_RANGE"  },
                //{ enumValue: TimeRangeEnum.ThreePm, labelValue12: "LABEL_THREEPM_RANGE", labelValue24: "LABEL_THREEPM24_RANGE"  },
                //{ enumValue: TimeRangeEnum.FourPm, labelValue12: "LABEL_FOURPM_RANGE", labelValue24: "LABEL_FOURPM24_RANGE"  },
                //{ enumValue: TimeRangeEnum.FivePm, labelValue12: "LABEL_FIVEPM_RANGE", labelValue24: "LABEL_FIVEPM24_RANGE"  },
                //{ enumValue: TimeRangeEnum.SixPm, labelValue12: "LABEL_SIXPM_RANGE", labelValue24: "LABEL_SIXPM24_RANGE"  },
                //{ enumValue: TimeRangeEnum.SevenPm, labelValue12: "LABEL_SEVENPM_RANGE", labelValue24: "LABEL_SEVENPM24_RANGE"  },
                { enumValue: TimeRangeEnum.EightPm, labelValue12: "LABEL_EIGHTPM_RANGE", labelValue24: "LABEL_EIGHTPM24_RANGE"  },
                { enumValue: TimeRangeEnum.NinePm, labelValue12: "LABEL_NINEPM_RANGE", labelValue24: "LABEL_NINEPM24_RANGE"  },
                { enumValue: TimeRangeEnum.TenPm, labelValue12: "LABEL_TENPM_RANGE", labelValue24: "LABEL_TENPM24_RANGE"  },
                { enumValue: TimeRangeEnum.ElvenPm, labelValue12: "LABEL_ELEVENPM_RANGE", labelValue24: "LABEL_ELEVENPM24_RANGE"  }
            ];

            this.startTimeRangeValue = 9;

            this.reportFormatList = this.reportFormat = [
                { id: Meevo.Model.FileFormatEnum.PDF, displayName: this.$translate.instant("LABEL_PDF"), counterName: this.$translate.instant("LABEL_PDF") + " ", isVisible: true },
                { id: Meevo.Model.FileFormatEnum.XLS, displayName: this.$translate.instant("LABEL_EXCEL"), counterName: this.$translate.instant("LABEL_EXCEL") + " ", isVisible: false },
                { id: Meevo.Model.FileFormatEnum.XLSX, displayName: this.$translate.instant("LABEL_EXCEL_WORKSHEET"), counterName: this.$translate.instant("LABEL_EXCEL_WORKSHEET") + " ", isVisible: true },
                { id: Meevo.Model.FileFormatEnum.PPTX, displayName: this.$translate.instant("LABEL_PPTX"), counterName: this.$translate.instant("LABEL_PPTX") + " ", isVisible: true },
                { id: Meevo.Model.FileFormatEnum.RTF, displayName: this.$translate.instant("LABEL_RTF"), counterName: this.$translate.instant("LABEL_RTF") + " ", isVisible: false },
                { id: Meevo.Model.FileFormatEnum.IMAGE, displayName: this.$translate.instant("LABEL_IMAGE"), counterName: this.$translate.instant("LABEL_IMAGE") + " ", isVisible: true },
                { id: Meevo.Model.FileFormatEnum.MHTML, displayName: this.$translate.instant("LABEL_MHTML"), counterName: this.$translate.instant("LABEL_MHTML") + " ", isVisible: false },
                { id: Meevo.Model.FileFormatEnum.DOCX, displayName: this.$translate.instant("LABEL_WORD"), counterName: this.$translate.instant("LABEL_WORD") + " ", isVisible: true },
                { id: Meevo.Model.FileFormatEnum.XPS, displayName: this.$translate.instant("LABEL_XPS"), counterName: this.$translate.instant("LABEL_XPS") + " ", isVisible: false }
            ];
        }

        /**
          * Base class override which defines what a DEFAULT model looks like.
        ***/
        createSectionModelInstance(postAdd: (data: any) => any): void {

            this.model = {
                displayName: "",
                objectState: Meevo.Model.ObjectStateEnum.Active,
                reportId: null,
                frequency: 1,
                reportDeliveryTypeEnum: Meevo.Model.DateTimeUnitsEnum.Monthly,
                isPerpetual: true,
                reportParamJson: {},
                startDate: new Date(),
                monthlySequencePositionEnum: this.defaultOccurrenceInterval,
                daysOfWeek: [],
                selectedPreset: null,
                forceCallback: true,
                employeeCategoryList: [],
                employeeRecipientList: [],
                userRecipientList: [],
                customUserRecipientList: [],
                reportDeliveryDayOfMonth: null,
                reportDeliveryDayOfWeek: null,
                reportDeliveryTimeOfDay: new Date(),
                applySecurity: true,
                reportDeliveryFileFormatEnum: this.reportFormat[0].id
            };

            this.model.reportDeliveryTimeOfDay.setHours(9, 0, 0, 0); // 9:00 AM

            this.startTimeRangeValue = 9;

            this.attachDateRangeWatcher();

            this.isLoading = false;
        }

        selectedPresetChanged = (preset: any) => {

            if (preset["name"].indexOf("WEEK") != -1) {
                if (this.model.reportDeliveryTypeEnum == Meevo.Model.DateTimeUnitsEnum.Monthly) {
                    this.model.reportDeliveryTypeEnum = Meevo.Model.DateTimeUnitsEnum.Weekly;
                    this.frequencyUnitChanged();
                }
                this.frequencyUnitReferenceData[0].isVisible = true;
                this.frequencyUnitReferenceData[1].isVisible = true;
                this.frequencyUnitReferenceData[2].isVisible = false;
            }
            else if (preset["status"] === PresetStatus.LastThirteenMonths ||
                     preset["status"] === PresetStatus.ThisYear) {
                this.model.reportDeliveryTypeEnum == Meevo.Model.DateTimeUnitsEnum.Monthly;
                this.frequencyUnitReferenceData[0].isVisible = false;
                this.frequencyUnitReferenceData[1].isVisible = false;
                this.frequencyUnitReferenceData[2].isVisible = true;
            }
            else if (preset["name"].indexOf("MONTH") != -1) {
                if (this.model.reportDeliveryTypeEnum == Meevo.Model.DateTimeUnitsEnum.Daily) {
                    this.model.reportDeliveryTypeEnum = Meevo.Model.DateTimeUnitsEnum.Monthly;
                    this.frequencyUnitChanged();
                }
                this.frequencyUnitReferenceData[0].isVisible = false;
                this.frequencyUnitReferenceData[1].isVisible = true;
                this.frequencyUnitReferenceData[2].isVisible = true;
            }
            else {
                this.frequencyUnitChanged();
                this.frequencyUnitReferenceData[0].isVisible = true;
                this.frequencyUnitReferenceData[1].isVisible = true;
                this.frequencyUnitReferenceData[2].isVisible = true;
            }
        }

        getStandingFrequency = (frequencyId: number) => {
            let frequency: StandingFrequency = _.find(this.frequencyUnitReferenceData, (item: StandingFrequency) => {
                return Number(item.id) === Number(frequencyId);
            })
            return frequency;
        }

        generateDaysList = () => {
            this.selectedDaysList = '';

            if (this.model.daysOfWeek) {
                _.each(this.model.daysOfWeek.sort(), (day: number, index) => {
                    this.selectedDaysList += this.daysRef[day]
                    if (index !== this.model.daysOfWeek.length - 1) {
                        this.selectedDaysList += ', ';
                    }
                })
            };

            if (this.selectedDaysList == "Monday") {
                this.model.reportDeliveryDayOfWeek = 1;
            }
            else if (this.selectedDaysList == "Tuesday") {
                this.model.reportDeliveryDayOfWeek = 2;
            }
            else if (this.selectedDaysList == "Wednesday") {
                this.model.reportDeliveryDayOfWeek = 3;
            }
            else if (this.selectedDaysList == "Thursday") {
                this.model.reportDeliveryDayOfWeek = 4;
            }
            else if (this.selectedDaysList == "Friday") {
                this.model.reportDeliveryDayOfWeek = 5;
            }
            else if (this.selectedDaysList == "Saturday") {
                this.model.reportDeliveryDayOfWeek = 6;
            }
            else if (this.selectedDaysList == "Sunday") {
                this.model.reportDeliveryDayOfWeek = 0;
            }

            return this.selectedDaysList;
        }

        numberOfOccurrencesChoiceChosen = () => {
            if (!this.isReadonly) {
                this.model.totalOccurrences = this.defaultTotalOccurrences;
                this.model.endDate = undefined;
                this.model.isPerpetual = false;
            }
        }

        endByChoiceChosen = function () {
            if (!this.isReadonly) {
                this.model.totalOccurrences = undefined;
                this.model.endDate = this.model.startDate || this.defaultEndDate;
                this.model.isPerpetual = false;
            }
        }

        isPerpetualChoiceChosen = () => {
            if (!this.isReadonly) {
                this.model.totalOccurrences = undefined;
                this.model.endDate = undefined;
                this.model.isPerpetual = true;
            }
        }

        dayOfWeekChoiceChosen = function () {
            if (!this.isReadonly && this.monthlyChoice == this.DAY_OF_WEEK_CHOICE) {
                this.model.monthlySequencePositionEnum = this.defaultOccurrenceInterval;
                this.model.reportDeliveryDayOfMonth = null;
                this.model.daysOfWeek = [];
            }
        }

        dayOfMonthChoiceChosen = function () {
            if (!this.isReadonly && this.monthlyChoice == this.DAY_OF_MONTH_CHOICE) {
                this.model.occurrenceInInterval = null;
                this.model.reportDeliveryDayOfMonth = this.defaultDayOfMonth;
                this.model.monthlySequencePositionEnum = null;
                this.model.reportDeliveryDayOfWeek = null;
                this.model.daysOfWeek = [];
            }
        }

        frequencyUnitChanged = function () {
                if (this.model.reportDeliveryTypeEnum == Meevo.Model.DateTimeUnitsEnum.Daily) {
                    this.model.reportDeliveryDayOfMonth = null;
                    this.model.reportDeliveryDayOfWeek = null;
                    this.model.monthlySequencePositionEnum = null;
                    this.model.daysOfWeek = [];
                    this.selectedDaysList = '';
                }
                else if (this.model.reportDeliveryTypeEnum == Meevo.Model.DateTimeUnitsEnum.Weekly) {
                    this.model.reportDeliveryDayOfMonth = null;
                    this.model.monthlySequencePositionEnum = null;
                }
                else if (this.model.reportDeliveryTypeEnum == Meevo.Model.DateTimeUnitsEnum.Monthly) {
                    if (this.monthlyChoice == this.DAY_OF_MONTH_CHOICE) {
                        if (this.model.reportDeliveryDayOfMonth == null) {
                            this.model.reportDeliveryDayOfMonth = this.defaultDayOfMonth;
                        }
                        this.model.monthlySequencePositionEnum = null;
                        this.model.reportDeliveryDayOfWeek = null;
                        this.model.daysOfWeek = [];
                    }
                    else {
                        if (this.model.monthlySequencePositionEnum == null) {
                            this.model.monthlySequencePositionEnum = this.defaultOccurrenceInterval;
                        }
                    }
                }
            this.formatDayOfWeek();
        }

        getWeekOccurrence = () => {
            const intervalType: SequencePositionEnum = this.model.monthlySequencePositionEnum;
            switch (intervalType) {
                case 14: return this.$translate.instant("LABEL_FIRST");
                case 15: return this.$translate.instant("LABEL_SECOND");
                case 17: return this.$translate.instant("LABEL_THIRD");
                case 18: return this.$translate.instant("LABEL_FOURTH");
                case 16: return this.$translate.instant("LABEL_LAST");
            }
        }

        setWeekOccurrence = () => {
            this.selectedWeekOccurrence = this.getWeekOccurrence();
        }

        getFrequencyWord = () => {
            for (var i = 0; i < this.frequencyUnitReferenceData.length; i++) {
                if (this.model.reportDeliveryTypeEnum == this.frequencyUnitReferenceData[i].id)
                    return this.frequencyUnitReferenceData[i].displayName;
            }
        }

        formatDayOfWeek = () => {
            if (!this.model) {
                return;
            }

            if (!this.selectedFrequency || (this.selectedFrequency && this.model.reportDeliveryTypeEnum && this.model.reportDeliveryTypeEnum !== this.selectedFrequency.id)) {
                this.selectedFrequency = this.getStandingFrequency(this.model.reportDeliveryTypeEnum);
            }

            if (!this.selectedWeekOccurrence) this.setWeekOccurrence();

            this.generateDaysList();
        }

        doesScheduleContainAtLeastOneRecipient = (): boolean => {
            return (this.model.customUserRecipientList.length >= 1) || (this.model.employeeRecipientList.length >= 1) || (this.model.employeeCategoryList.length >= 1) || (this.model.userRecipientList.length >= 1);
        }

        addCustomAddress = () => {

            if (this.customAddressSMS != "" && this.customAddressSMS != undefined) {
                let elm: any = $(HTMLElement).find("input#phone");
                if (elm && elm[0] && elm[0].value && elm[0].value.length > 0) {
                    const isValidNumber = elm.intlTelInput('isValidNumber');
                    if (!isValidNumber) {
                        return;
                    }
                }
            }

            if ((this.customAddressName == "" && this.customAddressEmail == "" && this.customAddressSMS == "")
                || (this.customAddressName == "" || this.customAddressName == undefined)
                || ((this.customAddressEmail == "" || this.customAddressEmail == undefined) && (this.customAddressSMS == "" || this.customAddressSMS == undefined))
                || (this.customAddressEmail != "" && this.customAddressEmail != undefined && this.customAddressSMS == undefined)
                || (this.customAddressSMS != "" && this.customAddressSMS != undefined && this.customAddressEmail == undefined)) {
                return;
            }
            else {
                var foundInListAlready, foundName, foundEmail, foundPhone;
                foundInListAlready = foundName = foundEmail = foundPhone = false;
                for (var i = 0; i < this.model.customUserRecipientList.length; i++) {
                    if (this.model.customUserRecipientList[i].fullName == this.customAddressName) {
                        foundName = foundInListAlready = true;
                        break;
                    }
                    if (this.model.customUserRecipientList[i].emailAddress == this.customAddressEmail) {
                        foundEmail = foundInListAlready = true;
                        break;
                    }
                    if (this.model.customUserRecipientList[i].phoneNumber == this.customAddressSMS) {
                        foundPhone = foundInListAlready = true;
                        break;
                    }
                }

                if (foundInListAlready) {
                    // say cannot add duplicate
                    if (foundName) {
                        this.modalService.alert("LABEL_CUSTOM_DELIVERY_ADDRESS_DUPLICATE_NAME");
                    }
                    else if(foundEmail){
                        this.modalService.alert("LABEL_CUSTOM_DELIVERY_ADDRESS_DUPLICATE_EMAIL");
                    }
                    else if(foundPhone){
                        this.modalService.alert("LABEL_CUSTOM_DELIVERY_ADDRESS_DUPLICATE_PHONE");
                    }
                }
                else { // Add a new user
                    this.model.customUserRecipientList.push({
                        fullName: this.customAddressName,
                        emailAddress: this.customAddressEmail ? this.customAddressEmail : null,
                        phoneNumber: this.customAddressSMS ? this.customAddressSMS : null,
                        phoneCountryCode: this.customAddressSMS ? this.customAddressSMSCountryCode : null
                    });
                }

                this.customAddressName = '';
                this.customAddressEmail = '';
                this.customAddressSMSIgnoreValidation = true;
                this.customAddressSMS = '';
                setTimeout(() => { this.customAddressSMSIgnoreValidation = false; }, 10);
            }
        }

        selectDifferentReport = () => {
            this.model = {
                displayName: "",
                reportId: null,
                objectState: Meevo.Model.ObjectStateEnum.Active,
                frequency: 1,
                reportDeliveryTypeEnum: Meevo.Model.DateTimeUnitsEnum.Monthly,
                isPerpetual: true,
                startDate: new Date(),
                monthlySequencePositionEnum: this.defaultOccurrenceInterval,
                reportParamJson: {},
                daysOfWeek: [],
                selectedPreset: null,
                forceCallback: true,
                employeeCategoryList: [],
                employeeRecipientList: [],
                userRecipientList: [],
                customUserRecipientList: [],
                reportDeliveryDayOfMonth: null,
                reportDeliveryDayOfWeek: null,
                reportDeliveryTimeOfDay: new Date(),
                applySecurity: true,
                reportDeliveryFileFormatEnum: Meevo.Model.FileFormatEnum.PDF
            };

            this.model.reportDeliveryTimeOfDay.setHours(9, 0, 0, 0); // 9:00 AM

            this.model.selectedPresetCallback = this.selectedPresetChanged;
        }

        setRunTime = () => {
            var newDateTime = new Date();

            newDateTime.setHours(this.startTimeRangeValue, 0, 0, 0);

            this.model.reportDeliveryTimeOfDay = newDateTime;
        }

        deleteCustomUser = (isReadonly, index) => {
            if (!isReadonly) {
                this.model.customUserRecipientList.splice(index, 1);
            }
        }

        public sectionModelRetrieved(): void {
            // Set Delivery Day Of Week Control
            if (this.model && this.model.reportDeliveryDayOfWeek != null) {
                this.model.daysOfWeek = [this.model.reportDeliveryDayOfWeek];
            }

            if (this.model && this.model["reportParameterJSON"] != null) {
                this.model.reportParamJson = JSON.parse(this.model["reportParameterJSON"]);
            }

            if (this.model && this.model.reportDeliveryTimeOfDay != null) {
                this.startTimeRangeValue = this.model.reportDeliveryTimeOfDay.getHours();
            }

            if (this.model && this.model.customUserRecipientList == null) {
                this.model.customUserRecipientList = [];
            }

            // load UI based on the existing data from the DB
            if (this.model != null && this.model.id != null && this.model.reportId != null) {

                // Send Monthly Report -> send weekly on specific day OR send on specific day of month
                // Day of Week
                if (this.model.reportDeliveryTypeEnum == Model.DateTimeUnitsEnum.Monthly && this.model.monthlySequencePositionEnum != null && this.model.reportDeliveryDayOfMonth == null) {
                    this.monthlyChoice = this.DAY_OF_WEEK_CHOICE;
                    this.generateDaysList();
                    this.setWeekOccurrence();
                }
                // Day of Month
                else if (this.model.reportDeliveryTypeEnum == Model.DateTimeUnitsEnum.Monthly && this.model.reportDeliveryDayOfMonth != null && this.model.monthlySequencePositionEnum == null && this.model.reportDeliveryDayOfWeek == null) {
                    this.monthlyChoice = this.DAY_OF_MONTH_CHOICE;
                    this.model.daysOfWeek = [];
                    this.model.monthlySequencePositionEnum = null;
                }

                this.model.frequency = 1; // frequency is always 1 now

                //this.selectedFrequency = this.frequencyUnitReferenceData[1];
                this.selectedReport = {
                    id: parseInt(this.model.reportId),
                    description: "",
                    displayName: "",
                    shortCut: "",
                    securityKey: "",
                    categoryId: null
                }

                // specific for Core Royalty Export
                this.updateFileFormatFilters(this.model.reportId);

                //this.selectedReport.id = parseInt(this.model.reportId);
                this.context.loadReportUI(this.selectedReport, true, this.context, true);
            }

            if (this.model) {
                this.model.daysOfWeek = this.model.daysOfWeek === undefined ? [] : this.model.daysOfWeek;
            }

            this.isLoading = false;
            this.attachDateRangeWatcher();
        }

        public setFirstSectionFlex(reportDisplayName: string): boolean {
            switch (reportDisplayName) {
                case 'AQ020':
                case 'AQ070':
                case 'AQ150':
                case 'AQ230':
                case 'AQ025':
                case 'DC025':
                case 'MI025':
                case 'MI210':
                case 'CO000':
                case 'MR055':
                case 'DB040':
                case 'MR245':
                case 'DR020':
                case 'MR035':
                case 'MR080':
                case 'MR085':
                case 'MR095':
                case 'MR100':
                case 'MR110':
                case 'MR115':
                case 'MR200':
                    return true;
                default:
                    return false;

            }
        }

        attachDateRangeWatcher():void {
            this.$scope.$watch(() => {
                if (this.model && this.model.reportParamJson)
                    return this.model.reportParamJson.selectedPreset;
                else
                    return;
            },
            (newVal: any, oldVal: any): void => {
                if (newVal && newVal != oldVal) {
                    this.selectedPresetChanged(newVal);
                }
            });
        }

        selected(subSectionContentKey?: string): void {
            if (this.model) {
                this.updateFileFormatFilters(this.model.reportId);
            }
        }

        updateFileFormatFilters(reportId: string) {
            // specific for Core Royalty Export
            if (reportId == "224") {
                this.reportFormat = _.filter(this.reportFormatList, (item: any) => { return item.id == Meevo.Model.FileFormatEnum.XLS || item.id == Meevo.Model.FileFormatEnum.XLSX });
            }
            else {
                this.reportFormat = this.reportFormatList;
            }
            if (this.model.reportDeliveryFileFormatEnum == null) {
                this.model.reportDeliveryFileFormatEnum = this.reportFormat[0].id;
            }
        }

        isDayOfWeekDelivery(): boolean {
            return (this.model.reportDeliveryTypeEnum == Meevo.Model.DateTimeUnitsEnum.Weekly
                    || (this.model.reportDeliveryTypeEnum == Meevo.Model.DateTimeUnitsEnum.Monthly && this.monthlyChoice == this.DAY_OF_WEEK_CHOICE))
        }
    }
}
